import api from '@/utils/api'

export default {
    getClients(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`clients` + (page ? range : ''))
    },

    getClient(id) {
        return api.get(`clients/${id}`)
    },

    createClient(data) {
        return api.post('clients', data)
    },

    updateClient(id, data) {
        return api.put(`clients/${id}`, data)
    },

    getAllClients() {
        return api.get(`clients/all`)
    },

    deleteClient(id) {
        return api.delete(`clients/${id}`)
    }
}
